import { ItaliaButton, ItaliaButtonProps } from '@framework/auth-open-web';
import { t } from '@framework/i18n';

interface IPaLoginButtonProps
  extends Omit<ItaliaButtonProps, 'image' | 'text'> {}

/**
 * Pulsante stile SPID per navigare al form di login dipendenti
 */
export function PaLoginButton(props: IPaLoginButtonProps) {
  return (
    <ItaliaButton
      style={{ width: '100%' }}
      image={require('./img/government-white.png')}
      text={t('user.login.pa-users.pa-button.utenti-pa', 'Utenti PA')}
      {...props}
    />
  );
}
